interface NewsletterTitleProps {
  title: string;
  formattedTitle: string;
  sectionRef: React.RefObject<HTMLDivElement>;
}

export default function NewsletterTitle({
  title,
  formattedTitle,
  sectionRef,
}: NewsletterTitleProps): React.ReactElement {
  return (
    <h5
      className="mb-5 border-t border-gray-850 pt-3 font-poppins text-lg uppercase text-gray-850"
      id={formattedTitle}
      ref={sectionRef}
    >
      {title}
    </h5>
  );
}
